import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
  product?: string;
}
const TestimonialCard = ({
  quote,
  author,
  location,
  product
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-dark-800 p-6 rounded-2xl border border-primary/30 shadow-lg" data-id="element-258">
    <div className="flex mb-3" data-id="element-259">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-260" />)}
    </div>
    <p className="text-cream/90 italic mb-4 text-base md:text-lg" data-id="element-261">"{quote}"</p>
    <div data-id="element-262">
      <p className="font-bold text-cream" data-id="element-263">{author}</p>
      <p className="text-sm text-primary" data-id="element-264">{location}</p>
      {product && <p className="text-xs text-cream/50 mt-1" data-id="element-265">{product}</p>}
    </div>
  </motion.div>;
export function TestimonialsFirstSet() {
  const testimonials = [{
    quote: 'En 3 días mi hijo empezó a pedirme actividades solo. Nunca pensé que iba a reemplazar YouTube con juegos de lógica y creatividad.',
    author: 'Valeria M.',
    location: 'Buenos Aires'
  }, {
    quote: 'El Tomo de Desafíos Numéricos fue un éxito total. Ahora me pide hacer matemática como si fuera un juego. Increíble.',
    author: 'Carla P.',
    location: 'Rosario'
  }, {
    quote: 'Las actividades de Creatividad al Límite nos conectaron de una forma que no teníamos hace meses. Le apagó el celu solo.',
    author: 'Martín G.',
    location: 'Córdoba'
  }];
  return <section className="bg-dark-900 py-8 px-4" data-id="element-266">
      <div className="max-w-6xl mx-auto" data-id="element-267">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-268">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-269" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSecondSet() {
  const testimonials = [{
    quote: 'Mi hijo tiene TDAH y pensé que era imposible. El protocolo de atención progresiva nos cambió la dinámica familiar completa. Ya no peleamos más por el celular.',
    author: 'Cecilia R.',
    location: 'Mendoza',
    product: 'Método + Mente Blindada'
  }, {
    quote: 'Los Desafíos Numéricos son adictivos. Mi hijo de 9 años me pide hacer matemática los sábados. Antes era impensable sacarlo de YouTube.',
    author: 'Roberto M.',
    location: 'Buenos Aires',
    product: 'Método Mente Enfocada'
  }, {
    quote: 'Mi hijo de 5 años pedía el celu apenas se despertaba. Con el Planner Visual, ahora sabe qué viene después y no lo pide más.',
    author: 'Sofía C.',
    location: 'La Plata',
    product: 'Método Mente Enfocada'
  }, {
    quote: 'Las tarjetas de Creatividad y Lógica nos salvaron los fines de semana. Ahora los tres jugamos juntos sin pantallas. No lo puedo creer.',
    author: 'Pablo A.',
    location: 'Neuquén',
    product: 'Método Mente Enfocada'
  }];
  return <section className="bg-dark-800 py-12 px-4" data-id="element-270">
      <div className="max-w-6xl mx-auto" data-id="element-271">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-cream mb-8" data-id="element-272">
          ❤️ MÁS FAMILIAS QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-273">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-274" />)}
        </div>
      </div>
    </section>;
}